module.exports = __webpack_public_path__ + "img/2019jucan-3.9c3f1839.jpg";